export const PollReducer = (state, action) => {
  switch (action.type) {
    case "LOAD_POLL":
      return {
        ...state,
        loading: false,
        poll: action.poll,
      };
    case 'NEW_VOTE':
      return {
        ...state,
        hasVoted: true,
        poll: {
          ...state.poll,
          vote_count: state.poll.vote_count+1,
          choices: state.poll.choices.map((c) => {
            let vote_count;

            if (c.id == action.choice) {
              vote_count = c.vote_count+1;
            } else {
              vote_count = c.vote_count;
            }

            return {
              ...c,
              vote_count,
            };
          }),
        },
      };
    case 'VOTE_REJECTED':
      return {
        ...state,
        hasVoted: true,
      };
    default:
      return state;
  }
};
